export default {
  BusinessStockChange: {
    header: {
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      categoryId: '商品分类',
      warehouseCode: '仓库编码',
      warehouseName: '仓库名称',
      recordTypeMeaning: '业务类型',
      warehouseType: '仓库类型',
      changeTime: '变动时间',
      recordCode: '相关单据'
    },

    table: {
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      categoryName: '商品分类',
      warehouseCode: '仓库编码',
      warehouseName: '仓库名称',
      recordTypeMeaning: '业务类型',
      warehouseTypeMeaning: '仓库类型',
      qtyTypeMeaning: '库存类型',
      preRealNum: '库存变动前',
      changeNum: '库存变动数',
      aftRealNum: '库存变动后',
      recordCode: '相关单据',
      operator: '操作人',
      creationDate: '操作时间'
    },

    voidBtn: '作废',
    confirmText1: '您正在',
    confirmText2: '的库存变动',
  }
};
